// Register the NearbyDeals service worker (production only).
// Dev/preview: unregister to avoid stale caches masking hot-reload changes.
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  window.addEventListener("load", () => {
    if (isLocalhost) {
      // Ensure no stale SW during local dev
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister());
      });
      return;
    }
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch(() => {
        /* SW registration is best-effort */
      });

    // Count iOS "add to home screen" installs on the first standalone launch.
    // iOS Safari does not fire `appinstalled`, so we detect standalone mode
    // once and mark the device as counted in localStorage.
    try {
      const standalone =
        window.matchMedia?.("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;
      const LOG_KEY = "nd_pwa_install_logged";
      if (standalone && !localStorage.getItem(LOG_KEY)) {
        const ua = navigator.userAgent || "";
        const isIOS = /iPad|iPhone|iPod/.test(ua) ||
          (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
        const platform = isIOS ? "ios" : /Android/i.test(ua) ? "android" : "desktop";
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/app/pwa-install`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ platform, source: "standalone-first-run" }),
          keepalive: true,
        })
          .then(() => {
            try { localStorage.setItem(LOG_KEY, "1"); } catch (_) { /* noop */ }
          })
          .catch(() => {});
      }
    } catch (_) { /* noop */ }
  });
}
